var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.routeName))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/corporations", role: "button" }
              },
              [_vm._v("\n                        back\n                    ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.createCorporation.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "row justify-content-md-center" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.name,
                          expression: "rules.name"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Name",
                        placeholder: "Enter name",
                        "data-vv-name": "name",
                        "cus-name": "name",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.name,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "name", $$v)
                        },
                        expression: "corporation.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.accountLimit,
                          expression: "rules.accountLimit"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Account Limit",
                        placeholder: "Enter Account Limit",
                        "data-vv-name": "account limit",
                        "cus-name": "account limit",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.accountLimit,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "accountLimit", $$v)
                        },
                        expression: "corporation.accountLimit"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.domain,
                          expression: "rules.domain"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Domain",
                        placeholder: "Enter Domain",
                        "data-vv-name": "domain",
                        "cus-name": "domain",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.domain,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "domain", $$v)
                        },
                        expression: "corporation.domain"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.invitation_code,
                          expression: "rules.invitation_code"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Type",
                        placeholder: "Enter Type",
                        "data-vv-name": "invitation_code",
                        "cus-name": "invitation_code",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.invitation_code,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "invitation_code", $$v)
                        },
                        expression: "corporation.invitation_code"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.status.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.active,
                              expression: "rules.active"
                            }
                          ],
                          attrs: {
                            label: "Status",
                            "data-vv-name": "active",
                            "cus-name": "active",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields,
                            list: _vm.status,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.corporation.active,
                            callback: function($$v) {
                              _vm.$set(_vm.corporation, "active", $$v)
                            },
                            expression: "corporation.active"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.contactFirstName,
                          expression: "rules.contactFirstName"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Contact First Name",
                        placeholder: "Enter Contact First Name",
                        "data-vv-name": "contact first name",
                        "cus-name": "contact first name",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.contactFirstName,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "contactFirstName", $$v)
                        },
                        expression: "corporation.contactFirstName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.contactLastName,
                          expression: "rules.contactLastName"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Contact Last Name",
                        placeholder: "Enter Contact Last Name",
                        "data-vv-name": "contact last name",
                        "cus-name": "contact last name",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.contactLastName,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "contactLastName", $$v)
                        },
                        expression: "corporation.contactLastName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.contactEmail,
                          expression: "rules.contactEmail"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Contact Email",
                        placeholder: "Enter Contact Email",
                        "data-vv-name": "contact email",
                        "cus-name": "contact email",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.contactEmail,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "contactEmail", $$v)
                        },
                        expression: "corporation.contactEmail"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.contactPhone,
                          expression: "rules.contactPhone"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Contact Phone",
                        placeholder: "Enter Contact Phone",
                        "data-vv-name": "contact phone",
                        "cus-name": "contact phone",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.contactPhone,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "contactPhone", $$v)
                        },
                        expression: "corporation.contactPhone"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.contactAddress,
                          expression: "rules.contactAddress"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Contact Address",
                        placeholder: "Enter Contact Address",
                        "data-vv-name": "contact address",
                        "cus-name": "contact address",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.contactAddress,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "contactAddress", $$v)
                        },
                        expression: "corporation.contactAddress"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.contactCity,
                          expression: "rules.contactCity"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Contact City",
                        placeholder: "Enter Contact City",
                        "data-vv-name": "contact city",
                        "cus-name": "contact city",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.contactCity,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "contactCity", $$v)
                        },
                        expression: "corporation.contactCity"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.contactState,
                          expression: "rules.contactState"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Contact State",
                        placeholder: "Enter Contact State",
                        "data-vv-name": "contact state",
                        "cus-name": "contact state",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.contactState,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "contactState", $$v)
                        },
                        expression: "corporation.contactState"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.contactZip,
                          expression: "rules.contactZip"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Contact Zip",
                        placeholder: "Enter Contact Zip",
                        "data-vv-name": "contact zip",
                        "cus-name": "contact zip",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.contactZip,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "contactZip", $$v)
                        },
                        expression: "corporation.contactZip"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("fg-text-area", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.description,
                          expression: "rules.description"
                        }
                      ],
                      attrs: {
                        rows: "2",
                        label: "Description",
                        placeholder: "Enter Description",
                        "data-vv-name": "description",
                        "cus-name": "description",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.description,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "description", $$v)
                        },
                        expression: "corporation.description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6 col-xs-12" },
                  [
                    _c("fg-image", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.largeImage,
                          expression: "rules.largeImage"
                        }
                      ],
                      attrs: {
                        type: "file",
                        label: "Large Image",
                        "data-vv-name": "large image",
                        "cus-name": "large image",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      on: { file: _vm.updateLargeImg },
                      model: {
                        value: _vm.corporation.largeImage,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "largeImage", $$v)
                        },
                        expression: "corporation.largeImage"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6 col-xs-12" },
                  [
                    _c("fg-image", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.smallImage,
                          expression: "rules.smallImage"
                        }
                      ],
                      attrs: {
                        type: "file",
                        label: "Small Image",
                        "data-vv-name": "small image",
                        "cus-name": "small image",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      on: { file: _vm.updateSmallImg },
                      model: {
                        value: _vm.corporation.smallImage,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "smallImage", $$v)
                        },
                        expression: "corporation.smallImage"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("legend", [_vm._v("Community Page Setting")]),
                _c("hr"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.corpStatus.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "Page Status",
                            "is-fields": _vm.fields,
                            list: _vm.corpStatus,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.corporation.enableCorporatePage,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.corporation,
                                "enableCorporatePage",
                                $$v
                              )
                            },
                            expression: "corporation.enableCorporatePage"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.spotlightSection.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "Spotlight Status",
                            "is-fields": _vm.fields,
                            list: _vm.spotlightSection,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.corporation.showSpotlightSection,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.corporation,
                                "showSpotlightSection",
                                $$v
                              )
                            },
                            expression: "corporation.showSpotlightSection"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.pinnedSection.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "Pinned Msgs Status",
                            "is-fields": _vm.fields,
                            list: _vm.pinnedSection,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.corporation.showPinnedMessages,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.corporation,
                                "showPinnedMessages",
                                $$v
                              )
                            },
                            expression: "corporation.showPinnedMessages"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.defaultCorpTabStatus.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "Default Tab",
                            "is-fields": _vm.fields,
                            list: _vm.defaultCorpTabStatus,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.corporation.defaultCorpTab,
                            callback: function($$v) {
                              _vm.$set(_vm.corporation, "defaultCorpTab", $$v)
                            },
                            expression: "corporation.defaultCorpTab"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "text",
                        label: "Spotlight Image URL",
                        placeholder: "Enter Spotlight Image"
                      },
                      model: {
                        value: _vm.corporation.spotlightPic,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "spotlightPic", $$v)
                        },
                        expression: "corporation.spotlightPic"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-text-area", {
                      attrs: {
                        type: "text",
                        label: "Corporate Page Welcome Message",
                        placeholder: "Enter Message",
                        "data-vv-name": "pageWelcomeMessage",
                        "cus-name": "pageWelcomeMessage"
                      },
                      model: {
                        value: _vm.corporation.pageWelcomeMessage,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "pageWelcomeMessage", $$v)
                        },
                        expression: "corporation.pageWelcomeMessage"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-text-area", {
                      attrs: {
                        type: "text",
                        label: "Enter Spotlight Quote",
                        placeholder: "Enter Spotlight Quote",
                        "data-vv-name": "Quote",
                        "cus-name": "Quote"
                      },
                      model: {
                        value: _vm.corporation.spotlightQuote,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "spotlightQuote", $$v)
                        },
                        expression: "corporation.spotlightQuote"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-text-area", {
                      attrs: {
                        type: "text",
                        label: "Enter Spotlight Paragraph 1",
                        placeholder: "Enter Spotlight Paragraph 1",
                        "data-vv-name": "paragraph4",
                        "cus-name": "paragraph4"
                      },
                      model: {
                        value: _vm.corporation.spotlightPara1,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "spotlightPara1", $$v)
                        },
                        expression: "corporation.spotlightPara1"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-text-area", {
                      attrs: {
                        type: "text",
                        label: "Enter Spotlight Paragraph 2",
                        placeholder: "Enter Spotlight Paragraph 2",
                        "data-vv-name": "paragraph4",
                        "cus-name": "paragraph4"
                      },
                      model: {
                        value: _vm.corporation.spotlightPara2,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "spotlightPara2", $$v)
                        },
                        expression: "corporation.spotlightPara2"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-text-area", {
                      attrs: {
                        type: "text",
                        label: "Enter Spotlight Paragraph 3",
                        placeholder: "Enter Spotlight Paragraph 3",
                        "data-vv-name": "paragraph4",
                        "cus-name": "paragraph4"
                      },
                      model: {
                        value: _vm.corporation.spotlightPara3,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "spotlightPara3", $$v)
                        },
                        expression: "corporation.spotlightPara3"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-text-area", {
                      attrs: {
                        type: "text",
                        label: "Private Events Heading",
                        placeholder: "Heading",
                        "data-vv-name": "privateEventHeading",
                        "cus-name": "privateEventHeading"
                      },
                      model: {
                        value: _vm.corporation.privateEventHeading,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "privateEventHeading", $$v)
                        },
                        expression: "corporation.privateEventHeading"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-text-area", {
                      attrs: {
                        type: "text",
                        label: "TONE Events Heading",
                        placeholder: "Heading",
                        "data-vv-name": "toneEventHeading",
                        "cus-name": "toneEventHeading"
                      },
                      model: {
                        value: _vm.corporation.toneEventHeading,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "toneEventHeading", $$v)
                        },
                        expression: "corporation.toneEventHeading"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-text-area", {
                      attrs: {
                        type: "text",
                        label: "Archive Section Heading",
                        placeholder: "Enter Heading",
                        "data-vv-name": "archiveEventHeading",
                        "cus-name": "archiveEventHeading"
                      },
                      model: {
                        value: _vm.corporation.archiveEventHeading,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "archiveEventHeading", $$v)
                        },
                        expression: "corporation.archiveEventHeading"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-text-area", {
                      attrs: {
                        type: "text",
                        label: "Pinned Message Heading",
                        placeholder: "Enter Heading",
                        "data-vv-name": "pinnedMessageHeading",
                        "cus-name": "pinnedMessageHeading"
                      },
                      model: {
                        value: _vm.corporation.pinnedMessageHeading,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "pinnedMessageHeading", $$v)
                        },
                        expression: "corporation.pinnedMessageHeading"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-text-area", {
                      attrs: {
                        type: "text",
                        label: "Playlist Section Heading",
                        placeholder: "Enter Heading",
                        "data-vv-name": "playlistHeading",
                        "cus-name": "playlistHeading"
                      },
                      model: {
                        value: _vm.corporation.playlistHeading,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "playlistHeading", $$v)
                        },
                        expression: "corporation.playlistHeading"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("legend", [_vm._v("Profile/Signup Page Settings")]),
                _c("hr"),
                _c("br"),
                _vm._v(" "),
                _vm.mobileFlags.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "Mobile Field Visibility",
                            "is-fields": _vm.fields,
                            list: _vm.mobileFlags,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.corporation.phoneFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.corporation, "phoneFlag", $$v)
                            },
                            expression: "corporation.phoneFlag"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dobFlags.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "DOB Field Visibility",
                            "is-fields": _vm.fields,
                            list: _vm.dobFlags,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.corporation.dobFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.corporation, "dobFlag", $$v)
                            },
                            expression: "corporation.dobFlag"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.shoeMotifFlags.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "Shoe-motif Flag",
                            "is-fields": _vm.fields,
                            list: _vm.shoeMotifFlags,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.corporation.showShoeMotif,
                            callback: function($$v) {
                              _vm.$set(_vm.corporation, "showShoeMotif", $$v)
                            },
                            expression: "corporation.showShoeMotif"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("legend", [_vm._v("Corporation Private Video Settings")]),
                _c("hr"),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "text",
                        label: "Private Video Section Heading",
                        placeholder: "Enter Message",
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.videoTabHeading,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "videoTabHeading", $$v)
                        },
                        expression: "corporation.videoTabHeading"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "text",
                        label: "Video Codes (To show)",
                        placeholder: "Enter Video Codes (comma separated)",
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.csvShowVideoCodes,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "csvShowVideoCodes", $$v)
                        },
                        expression: "corporation.csvShowVideoCodes"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      attrs: {
                        type: "text",
                        label: "Video Codes (To hide)",
                        placeholder: "Enter Video Codes (comma separated)",
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.corporation.csvHiddenVideoCodes,
                        callback: function($$v) {
                          _vm.$set(_vm.corporation, "csvHiddenVideoCodes", $$v)
                        },
                        expression: "corporation.csvHiddenVideoCodes"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("legend", [_vm._v("Custom Banner Status")]),
                _c("br"),
                _vm._v(" "),
                _vm.giftIconStatus.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "Gifting Status",
                            "is-fields": _vm.fields,
                            list: _vm.giftIconStatus,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.corporation.giftIconState,
                            callback: function($$v) {
                              _vm.$set(_vm.corporation, "giftIconState", $$v)
                            },
                            expression: "corporation.giftIconState"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showCustomMessageFlag
                  ? _c(
                      "div",
                      { staticClass: "col-md-8" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Custom Message",
                            placeholder: "Enter Custom Message",
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.corporation.giftIconMessage,
                            callback: function($$v) {
                              _vm.$set(_vm.corporation, "giftIconMessage", $$v)
                            },
                            expression: "corporation.giftIconMessage"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showCustomMessageFlag
                  ? _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Enter URL (Optional)",
                            placeholder: "Enter Url",
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.corporation.giftIconUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.corporation, "giftIconUrl", $$v)
                            },
                            expression: "corporation.giftIconUrl"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("legend", [_vm._v("Event Banner Status")]),
                _c("br"),
                _vm._v(" "),
                _vm.eventBannerStatus.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "Event Banner Behavior",
                            "is-fields": _vm.fields,
                            list: _vm.eventBannerStatus,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.corporation.bnrLinkState,
                            callback: function($$v) {
                              _vm.$set(_vm.corporation, "bnrLinkState", $$v)
                            },
                            expression: "corporation.bnrLinkState"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showCustomBannerFlag
                  ? _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("label", [_vm._v("Start Date")]),
                        _vm._v(" "),
                        _c("datetime", {
                          attrs: {
                            "input-class": "form-control",
                            placeholder: "Choose a Date",
                            type: "datetime",
                            "min-datetime": _vm.startDate,
                            "input-format": "DD-MM-YYYY HH:mm",
                            "auto-continue": "",
                            required: ""
                          },
                          model: {
                            value: _vm.startDate,
                            callback: function($$v) {
                              _vm.startDate = $$v
                            },
                            expression: "startDate"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showCustomBannerFlag
                  ? _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("label", [_vm._v("End Date")]),
                        _vm._v(" "),
                        _c("datetime", {
                          attrs: {
                            "input-class": "form-control",
                            placeholder: "Choose a Date",
                            type: "datetime",
                            "input-format": "DD-MM-YYYY HH:mm",
                            "min-datetime": _vm.startDate,
                            "auto-continue": "",
                            required: ""
                          },
                          model: {
                            value: _vm.endDate,
                            callback: function($$v) {
                              _vm.endDate = $$v
                            },
                            expression: "endDate"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.bnrLinkState === "3"
                  ? _c(
                      "div",
                      { staticClass: "col-md-8" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Custom Banner",
                            placeholder: "Enter Custom Banner",
                            "is-fields": _vm.fields,
                            required: ""
                          },
                          model: {
                            value: _vm.corporation.bnrCustomMsg,
                            callback: function($$v) {
                              _vm.$set(_vm.corporation, "bnrCustomMsg", $$v)
                            },
                            expression: "corporation.bnrCustomMsg"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.bnrLinkState === "3"
                  ? _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Enter URL",
                            placeholder: "Enter Url",
                            "is-fields": _vm.fields,
                            required: ""
                          },
                          model: {
                            value: _vm.corporation.bnrCustomMsgUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.corporation, "bnrCustomMsgUrl", $$v)
                            },
                            expression: "corporation.bnrCustomMsgUrl"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 text-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-fill btn-block",
                  attrs: { type: "submit", disabled: _vm.errors.any() }
                },
                [
                  _vm._v(
                    "\n                            Create Corporation\n                        "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4627b074", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4627b074","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Corporations/CreateCorporation.vue
// module id = fxM9
// module chunks = 0